// extracted by mini-css-extract-plugin
export default {"cost":"styles_cost__pQX7R","switch":"styles_switch__P23J9"};